/**
 * 排泄カテゴリリスト
 */
export const DEFECATION_CATEGORY_TYPE = ['なし', '普通', '硬い便', '軟便', '下痢', '小便'] as const;

/**
 * 排泄カテゴリ
 */
export type DefecationCategoryType = typeof DEFECATION_CATEGORY_TYPE[number];
